<div class="esn-space-tree" role="tree" [attr.aria-label]="label()">
  @for (row of rows(); track row.node.id) {
    <esn-tree-row
      class="esn-space-tree__row"
      [attr.data-node-id]="row.node.id"
      [attr.tabindex]="row.node.id === tabStopId() ? 0 : -1"
      [kind]="rowKind(row)"
      [level]="row.level"
      [indent]="indent()"
      [fullWidth]="true"
      [chevronTabbable]="false"
      [meta]="row.node.meta ?? null"
      [chip]="row.node.chip ?? null"
      [contentType]="row.node.kind === 'content' ? (row.node.contentType ?? 'video') : null"
      [external]="row.node.external ?? false"
      [expanded]="isOpen(row.node.id)"
      (expandedChange)="setOpen(row.node.id, $event)"
      (click)="onClick(row)"
      (keydown)="onKeydown($event, row)"
    >
      {{ row.node.label }}
    </esn-tree-row>
  }
</div>
